export default __webpack_public_path__ + "resources/icons/n131-00e4.webp";